<template>
  <h-header>
    <template v-slot:actions>
      <div class="d-flex justify-end">
        <v-btn
          @click="openCreateAppointmentModal"
          color="primary"
          elevation="0"
        >
          <v-icon left>mdi-plus</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t(`create.label.appointment`) }}
          </span>
        </v-btn>
        <v-btn
          @click="openModal('BATCH_SCHEDULE_MODAL')"
          color="primary"
          elevation="0"
          class="ml-3"
        >
          <v-icon small> mdi-upload </v-icon>
        </v-btn>

        <v-btn color="primary" elevation="0" class="ml-3" @click="generateLinkExcelAppointments">
          <v-icon left>mdi-arrow-down-bold-box-outline</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('appointment.buttons.generateExcel') }}
          </span>
        </v-btn>
      </div>
    </template>
  </h-header>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AppointmentListHeader',

  methods: {
    ...mapActions(['openModal', 'downloadRealEstateAppointmentExcel']),

    openCreateAppointmentModal() {
      const modal = this.$root.$children[0].$refs?.createAppointmentModal?.$refs?.createModal
      modal.dialog = true
    },

    async generateLinkExcelAppointments() {
      await this.downloadRealEstateAppointmentExcel()
    },
  },
}
</script>
